import { css } from '@emotion/react';
import { FC } from 'react';
import { Step } from './Step';
import { StepperTrack } from './StepperTrack';
import { useStepper } from './useStepper';

export interface StepProp {
  label: string;
}

export interface StepperProps {
  steps: Array<StepProp>;
  activeStep: number;
}

const applyMainStyles = () => (theme) => {
  return css(theme.stepper.container);
};

const stepsStyle = () => (theme) => {
  return css(theme.stepper.steps);
};

export const Stepper: FC<StepperProps> = ({
  steps,
  activeStep: activeStepProp,
}: StepperProps) => {
  const activeStep = Math.min(activeStepProp, steps.length - 1);
  const { stepSize } = useStepper(steps.length || 1, activeStep);

  if (steps.length < 2) {
    console.error('Stepper must have at least 2 steps');
    return null;
  }

  if (activeStepProp >= steps.length) {
    console.warn('Active step is greater than the steps count');
  }

  return (
    <div css={applyMainStyles()}>
      <div css={stepsStyle()}>
        {steps.map((s, idx) => (
          <Step
            key={idx}
            index={idx}
            activeStep={activeStep}
            stepSize={stepSize}
            label={s.label}
          />
        ))}
      </div>
      <StepperTrack steps={steps} activeStep={activeStep} />
    </div>
  );
};
